import { render } from "./VersionAlert.vue?vue&type=template&id=0653c916"
import script from "./VersionAlert.vue?vue&type=script&lang=js"
export * from "./VersionAlert.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"static/js/components-wa/messages/VersionAlert.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0653c916"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0653c916', __exports__)) {
    api.reload('0653c916', __exports__)
  }
  
  module.hot.accept("./VersionAlert.vue?vue&type=template&id=0653c916", () => {
    api.rerender('0653c916', render)
  })

}


export default __exports__